// A CROWN'S Y IS THE READ OF ONE DRAWN LEVEL (FT1, the flying trees of
// 2026-10-31; APP_FORESTVOL §4c). Crowns and shrubs stand on the DRAWN ground
// (terrain.groundDrawn, the finest drawn node), and a read off a level-k node
// is off the L0 ground by up to that level's tolerance (0.5 m · 2^(k−1): 64 m
// at L8). The ground tree draws the coarse levels first (at load, behind the
// Map) and refines after the read, so a read kept by eye distance alone
// stood a crown tens of metres in the air next to the player. The rule:
//   - every read carries its level (yk: Y_NONE before the first);
//   - a read is taken again once a FINER node is drawn under it (yStale);
//   - a set built from reads (a tree chunk, the hero fan, the zoom set, the
//     shrub pass) records one record per coarse node it read (YFrom) and is
//     built again once the ground tree moved (gen) and a finer node is drawn
//     at one of them (yMoved, at most every `every` ms).
// A coarser node drawn later (the eye walked away) keeps the finer read: the
// truer ground, its screen error under the coarse node's.
// Readers: trees.js Forest, shrubs.js Shrubs; gate check-forest-handoff.mjs
// yRows (+ check-forest-ground.mjs on a bake).
export const Y_NONE = 255;

const side = (k) => 128 * (1 << k);   // groundm/lookup.js nodeSide

// a read on level k at (x, z) whose ground has a finer node drawn now
export function yStale(ground, x, z, k) {
  if (k === 0 || k === Y_NONE) return false;
  const j = ground.drawnLevel(x, z);
  return j >= 0 && j < k;
}

export class YFrom {
  constructor() { this.at = new Map(); }

  // a read on level k at (x, z): the first record of each coarse node
  add(k, x, z) {
    if (k === 0 || k === Y_NONE) return;
    const s = side(k), key = `${k}_${Math.floor((x - 0.25) / s)}_${Math.floor((z - 0.25) / s)}`;
    if (!this.at.has(key)) this.at.set(key, [k, x, z]);
  }

  // a finer node is drawn at one of the reads
  stale(ground) {
    for (const [k, x, z] of this.at.values()) if (yStale(ground, x, z, k)) return true;
    return false;
  }

  get size() { return this.at.size; }
}

// st = { from: YFrom, gen, at } (the set's reads, the ground gen and time it
// was last checked at): true once the ground tree moved since and the set
// is stale; checks at most every `every` ms, re-arms on the gen it read
export function yMoved(st, ground, now, every) {
  const gen = ground && Number.isFinite(ground.gen) ? ground.gen : 0;
  if (!st || !st.from.size || gen === st.gen || now - st.at < every) return false;
  st.gen = gen;
  st.at = now;
  return st.from.stale(ground);
}
